import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { RouteErrorBoundary } from "@/components/feedback";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/**
 * Layout das 14 telas de painel do organizador (visão geral … whatsapp):
 * sidebar fixa no desktop, off-canvas (Sheet, componente shadcn) no mobile.
 *
 * O `Sheet`/Radix Dialog já cobre "de graça" o comportamento do legado
 * (`app/web/js/app.js`): fecha no `Escape` e ao clicar no scrim — só o
 * "fecha ao clicar num item de nav" precisa de código explícito, feito
 * abaixo reagindo a troca de rota.
 */
export function PanelLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-bg">
      <aside className="hidden w-[236px] shrink-0 border-r border-border bg-sidebar lg:block">
        <Sidebar />
      </aside>

      <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
        <SheetContent
          side="left"
          className="w-[236px] max-w-[85vw] gap-0 bg-sidebar p-0 sm:max-w-[236px]"
        >
          <SheetTitle className="sr-only">Navegação</SheetTitle>
          <Sidebar onNavigate={() => setMobileNavOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenNav={() => setMobileNavOpen(true)} />
        <main className="flex-1 overflow-y-auto px-[var(--page-px)] py-6">
          <RouteErrorBoundary>
            <Outlet />
          </RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
